
import {
  GETSUBSECTION
 
} from "../actions/type";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup partyTypeList Cases
    case GETSUBSECTION:
      return {
        ...state,
        subsection: action.payload.data,
      };
    
    default:
      return state;
  }
}
